import { render, staticRenderFns } from "./ImportsUploader.vue?vue&type=template&id=51d0be06"
import script from "./ImportsUploader.vue?vue&type=script&lang=ts"
export * from "./ImportsUploader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports